import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const PaymentConfirm = () => {
  const [params, setParams] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const paramsObject = {};

    for (let [key, value] of queryParams.entries()) {
      paramsObject[key] = value;
    }

    const userData = JSON.parse(sessionStorage.getItem("user"));

    if (paramsObject.status === "S") {
      if (paramsObject.type === "calladoc") {
        const formData = new FormData();
        formData.append("pid", paramsObject.pid);
        formData.append("patientid", userData.applicationUserId);

        fetch(
          "https://easypaiseminiapp.webddocsystems.com/public/api/v1/subscription",
          {
            method: "POST",
            body: formData,
          }
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("API Response:", data);
            sessionStorage.setItem("redirectFromPaymentSuccess", "true");
            navigate("/");
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else if (paramsObject.type === "insurance") {
        const payload = {
          openId: userData.openId,
          orderId: paramsObject.tid,
          coverage: "0",
          transactionStatus: "Success",
          mobileNumber: userData.userMsisdn,
          name: userData.userName,
          transactionId: paramsObject.tid,
          packageId: parseInt(paramsObject.pid, 10),
        };

        fetch(
          "https://insuranceservice.webddocsystems.com/api/MiniApp/ActivatePackage",
          {
            method: "POST",
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
              Authorization:
                "Basic ZlJqZGZVbWFzOmFmMzNhZmNhODAwNzZkOWMxMTViOGU0NjAyZjc4YTIx",
            },
            body: JSON.stringify(payload),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.responseCode === "0000") {
              sessionStorage.setItem("redirectFromPaymentSuccess", "true");
              navigate("/");
              // navigate(-1);
            } else {
              console.error("Transaction failed:", data.message);
              // Handle failure (e.g., show an alert or error message)
              sessionStorage.setItem("redirectFromPaymentFaild", "true");
              navigate("/");
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else if (paramsObject.type === "rsa") {
        const payload = {
          openId: userData.openId,
          orderId: paramsObject.tid,
          coverage: "0",
          transactionStatus: "Success",
          mobileNumber: userData.userMsisdn,
          name: userData.userName,
          transactionId: paramsObject.tid,
          packageId: parseInt(paramsObject.pid, 10),
        };

        fetch(
          "https://insuranceservice.webddocsystems.com/api/MiniApp/MiniAppPackageActivationRSA",
          {
            method: "POST",
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
              Authorization:
                "Basic ZlJqZGZVbWFzOmFmMzNhZmNhODAwNzZkOWMxMTViOGU0NjAyZjc4YTIx",
            },
            body: JSON.stringify(payload),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.responseCode === "0000") {
              sessionStorage.setItem("redirectFromPaymentSuccess", "true");
              navigate("/");
              // navigate(-1);
            } else {
              console.error("Transaction failed:", data.message);
              // Handle failure (e.g., show an alert or error message)
              sessionStorage.setItem("redirectFromPaymentFaild", "true");
              navigate("/");
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else if (paramsObject.type === "agri") {
        const payload = {
          openId: userData.openId,
          orderId: paramsObject.tid,
          coverage: "0",
          transactionStatus: "Success",
          mobileNumber: userData.userMsisdn,
          name: userData.userName,
          transactionId: paramsObject.tid,
          packageId: parseInt(paramsObject.pid, 10),
        };

        fetch(
          "https://insuranceservice.webddocsystems.com/api/MiniApp/MiniAppPackageActivationAgri",
          {
            method: "POST",
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
              Authorization:
                "Basic ZlJqZGZVbWFzOmFmMzNhZmNhODAwNzZkOWMxMTViOGU0NjAyZjc4YTIx",
            },
            body: JSON.stringify(payload),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.responseCode === "0000") {
              sessionStorage.setItem("redirectFromPaymentSuccess", "true");
              navigate("/");
              // navigate(-1);
            } else {
              console.error("Transaction failed:", data.message);
              // Handle failure (e.g., show an alert or error message)
              sessionStorage.setItem("redirectFromPaymentFaild", "true");
              navigate("/");
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else if (paramsObject.type === "vets") {
        const payload = {
          openId: userData.openId,
          orderId: paramsObject.tid,
          coverage: "0",
          transactionStatus: "Success",
          mobileNumber: userData.userMsisdn,
          name: userData.userName,
          transactionId: paramsObject.tid,
          packageId: parseInt(paramsObject.pid, 10),
        };

        fetch(
          "https://insuranceservice.webddocsystems.com/api/MiniApp/MiniAppPackageActivationVetnary",
          {
            method: "POST",
            headers: {
              Accept: "text/plain",
              "Content-Type": "application/json",
              Authorization:
                "Basic ZlJqZGZVbWFzOmFmMzNhZmNhODAwNzZkOWMxMTViOGU0NjAyZjc4YTIx",
            },
            body: JSON.stringify(payload),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.responseCode === "0000") {
              sessionStorage.setItem("redirectFromPaymentSuccess", "true");
              navigate("/");
              // navigate(-1);
            } else {
              console.error("Transaction failed:", data.message);
              // Handle failure (e.g., show an alert or error message)
              sessionStorage.setItem("redirectFromPaymentFaild", "true");
              navigate("/");
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else {
        navigate("/");
      }
    } else {
      alert("failed");
    }

    console.log(paramsObject);
    setParams(paramsObject);
  }, [navigate]);

  return (
    <div>
     
    </div>
  );
};

export default PaymentConfirm;
